var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-phone-change',{staticClass:"pt-3",attrs:{"new-user":false,"form-message":"Введите номер телефона"},on:{"done":_vm.onDone}})}
var staticRenderFns = []

export { render, staticRenderFns }